import React from 'react';
import i18n from 'i18next';

// Mobile drawer-ийн дэд цэс: энгийн жижиг текст мөр.
const MenuDrawerSubItem = ({ menu, onClick, style = '', textStyle = '' }) => {
    const menuName =
        menu.names?.find((item) => item.langCode === i18n.language)?.name ||
        menu.names?.find((item) => item.langCode === 'mn')?.name;

    return (
        <li
            className={`py-3 border-b border-line cursor-pointer text-[15px] text-ink hover:text-ink/70 ${style} ${textStyle}`}
            onClick={onClick}
        >
            {menuName}
        </li>
    );
};

export default MenuDrawerSubItem;
